module.exports = __webpack_public_path__ + "img/win.ac1e9fc1.png";